// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropDownOptions__list-f2d6e7 {
  width: var(--dropdown-width);
  height: 300px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--base-10);
  overflow: auto;
  z-index: 3;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.14), 0 3px 14px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.DropDownOptions__item-b6764c {
  width: 100%;
  display: flex;
  align-items: center;
  height: 40px;
  font: var(--font-body-4);
  color: var(--base-110);
  cursor: pointer;
}

.DropDownOptions__item-b6764c:hover,
.DropDownOptions__item-b6764c:focus {
  background-color: var(--base-20);
}

.DropDownOptions__name-c322ea {
  margin-inline-start: 19px;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
}

.DropDownOptions__name-selected-d82e9f {
  font: var(--font-body-2);
  font-weight: bold;
}

.DropDownOptions__arrow-dcf660 {
  width: 10px;
  height: 6px;
  fill: var(--base-80);
}

.DropDownOptions__mark-container-eb2434 {
  width: 18px;
  margin-inline-start: 19px;
}

.DropDownOptions__mark-e62fd2 {
  width: 18px;
  height: 13px;
  fill: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/form/DropDown/DropDownOptions/DropDownOptions.styles.m.css"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,gCAAA;EACA,cAAA;EACA,UAAA;EACA,uGAAA;EAEA,kBAAA;AAAF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,sBAAA;EACA,eAAA;AAAF;;AAGA;;EAEE,gCAAA;AAAF;;AAGA;EACE,yBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AAAF;;AAGA;EACE,wBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,WAAA;EACA,WAAA;EACA,oBAAA;AAAF;;AAGA;EACE,WAAA;EACA,yBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AAAF","sourcesContent":[".list {\n  width: var(--dropdown-width);\n  height: 300px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: var(--base-10);\n  overflow: auto;\n  z-index: 3;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.14),\n    0 3px 14px rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n}\n\n.item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  font: var(--font-body-4);\n  color: var(--base-110);\n  cursor: pointer;\n}\n\n.item:hover,\n.item:focus {\n  background-color: var(--base-20);\n}\n\n.name {\n  margin-inline-start: 19px;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n}\n\n.name-selected {\n  font: var(--font-body-2);\n  font-weight: bold;\n}\n\n.arrow {\n  width: 10px;\n  height: 6px;\n  fill: var(--base-80);\n}\n\n.mark-container {\n  width: 18px;\n  margin-inline-start: 19px;\n}\n\n.mark {\n  width: 18px;\n  height: 13px;\n  fill: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `DropDownOptions__list-f2d6e7`,
	"item": `DropDownOptions__item-b6764c`,
	"name": `DropDownOptions__name-c322ea`,
	"name-selected": `DropDownOptions__name-selected-d82e9f`,
	"nameSelected": `DropDownOptions__name-selected-d82e9f`,
	"arrow": `DropDownOptions__arrow-dcf660`,
	"mark-container": `DropDownOptions__mark-container-eb2434`,
	"markContainer": `DropDownOptions__mark-container-eb2434`,
	"mark": `DropDownOptions__mark-e62fd2`
};
module.exports = ___CSS_LOADER_EXPORT___;
